import { createContext, useContext } from "react";
import type { WeeklyDungeon, WeeklyDungeonState, DungeonStageDefinition, DungeonStageProgress, DungeonProgressStatus } from "../types/games";
import type { ProgressExperienceItem } from "../types/experience";
import type { Rating } from "../types/rating";

export interface WeeklyDungeonActionResult {
  ok: boolean;
  message?: string;
}
export interface DungeonStats {
  completed: number;
  epicCompleted: number;
  legendaryCompleted: number;
}
export interface WeeklyDungeonView extends WeeklyDungeon {
  userStatus: DungeonProgressStatus | "locked";
  available: boolean;
}
export interface WeeklyDungeonStageView extends Omit<DungeonStageDefinition, "status">, Omit<DungeonStageProgress, "requiredMoviesCount"> {
  completedMoviesCount: number;
  remainingMs: number;
  matchedMovies: Rating[];
}
export interface WeeklyDungeonsContextValue {
  loaded: boolean;
  canManage: boolean;
  weekId: string;
  dungeons: WeeklyDungeonView[];
  selectedDungeon: WeeklyDungeon | null;
  activeDungeon: WeeklyDungeon | null;
  userState: WeeklyDungeonState;
  currentStage: WeeklyDungeonStageView | null;
  completedDungeonQuests: ProgressExperienceItem[];
  dungeonStats: DungeonStats;
  legendaryChance: number;
  selectionDeadline: number | null;
  selectionClosed: boolean;
  selectDungeon: (dungeonId: string) => Promise<WeeklyDungeonActionResult>;
  hasActivity: boolean | ((dedupeKey: string) => Promise<boolean>);
}

const unavailableWeeklyDungeons: WeeklyDungeonsContextValue = {
  loaded: false,
  canManage: false,
  weekId: "",
  dungeons: [],
  selectedDungeon: null,
  activeDungeon: null,
  userState: {},
  currentStage: null,
  completedDungeonQuests: [],
  dungeonStats: { completed: 0, epicCompleted: 0, legendaryCompleted: 0 },
  legendaryChance: 0,
  selectionDeadline: null,
  selectionClosed: false,
  selectDungeon: async () => ({ ok: false, message: "Экспедиции ещё загружаются" }),
  hasActivity: false
};

export const WeeklyDungeonsContext = createContext(unavailableWeeklyDungeons);

export const useWeeklyDungeons = () => useContext(WeeklyDungeonsContext);
